import { atom } from "jotai";

// Create a base atom for the outline state
const baseOutlineAtom = atom<string>("");
baseOutlineAtom.debugLabel = "baseOutlineAtom";

export const basePartialOutlineAtom = atom<string>("");
basePartialOutlineAtom.debugLabel = "basePartialOutlineAtom";

/**
 * This atom is used to store the partial outline.
 * It is used to store the partial outline from the streaming completion.
 * It stores the partial outline as a string.
 */
export const partialOutlineAtom = atom<
  string,
  [string | ((prev: string) => string)],
  void
>(
  (get) => get(basePartialOutlineAtom),
  (get, set, update: string | ((prev: string) => string)) => {
    const currentPartialOutline = get(basePartialOutlineAtom);
    const nextValue =
      typeof update === "function" ? update(currentPartialOutline) : update;
    set(basePartialOutlineAtom, nextValue);
  },
);
partialOutlineAtom.debugLabel = "partialOutlineAtom";

/**
 * This atom is used to store the outline.
 * It is used to store the outline from the streaming completion.
 * It stores the outline as a string.
 */
export const outlineAtom = atom<
  string,
  [string | ((prev: string) => string)],
  void
>(
  // Getter
  (get) => get(baseOutlineAtom),
  // Setter
  (get, set, update: string | ((prev: string) => string)) => {
    // Get current outline state
    const currentOutline = get(baseOutlineAtom);
    // Apply the update (handling both direct and functional updates)
    const nextValue =
      typeof update === "function" ? update(currentOutline) : update;
    // Update outline state
    set(baseOutlineAtom, nextValue);
  },
);
outlineAtom.debugLabel = "outlineAtom";
